var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2659.9 183.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebf2fa;\n      }\n\n      .cls-2 {\n        fill: #294272;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: #93c933;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #fdc000;\n      }\n\n      .cls-7 {\n        fill: #ffdb2f;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1238.12,
    y: -1238.12,
    width: 183.67,
    height: 2659.9,
    transform: "translate(1421.79 -1238.12) rotate(90)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "933.6 1012.43 933.6 516.9 473.27 -237.91 473.27 686.56 672.22 1012.43 933.6 1012.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1378.87,129.01c197.41-17.21,353.18-215.94,353.18-458.74,0-23.93-1.52-47.43-4.44-70.38h-348.74s0,529.12,0,529.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1727.61-400.11c2.92,22.95,4.44,46.45,4.44,70.38,0,242.8-155.76,441.54-353.18,458.74V437.16c179.5-9.33,339.69-108.54,450.51-261.33V-400.11s-101.77,0-101.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1378.87,437.16V129.01c-9.19,.8-18.43,1.35-27.79,1.35-210.4,0-380.96-205.99-380.96-460.09,0-23.93,1.52-47.43,4.44-70.38h-40.95s0,649.24,0,649.24c111.68,117.58,257.69,188.8,417.48,188.8,9.31,0,18.57-.29,27.79-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M933.6,249.13V-400.11s-215.47,0-215.47,0c-1.75,23.18-2.69,46.65-2.69,70.38,0,230.99,84.49,438.13,218.16,578.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.04,275.18c0,57.67-12.28,111.87-33.84,159.02l154.07,252.36V-237.91s-98.92-162.2-98.92-162.2H19.39s0,343.24,0,343.24l5.7,9.33c17.81-4.42,36.26-6.74,55.16-6.74,150.66,0,272.8,147.51,272.8,329.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.61,158.05L25.09-47.54c-.11,.03-.22,.06-.34,.09l125.04,204.8c.27,.24,.55,.47,.82,.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.24,130.45c25.94,0,49.93,9.99,69.54,26.9L24.75-47.45c-1.79,.45-3.58,.92-5.36,1.41V150.51c17.84-12.73,38.63-20.06,60.85-20.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.72,228.67l125.48,205.53c21.56-47.15,33.84-101.35,33.84-159.02,0-181.96-122.14-329.46-272.8-329.46-18.9,0-37.34,2.32-55.16,6.74l125.52,205.6c19.84,17.42,35.08,42,43.11,70.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.72,228.67l-43.11-70.62c-.27-.24-.55-.47-.82-.71l44.27,72.51c-.11-.4-.22-.79-.33-1.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.6,516.9V249.13c-133.67-140.73-218.16-347.87-218.16-578.86,0-23.73,.94-47.2,2.69-70.38h-244.86s0,162.2,0,162.2l460.33,754.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1351.08,130.36c9.36,0,18.6-.55,27.79-1.35V-400.11s-404.32,0-404.32,0c-2.92,22.95-4.44,46.45-4.44,70.38,0,254.1,170.56,460.09,380.96,460.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1479.5,1012.43c-61.8-68.13-100.58-166.21-100.58-275.23,0-205.76,138.11-372.56,308.49-372.56,51.2,0,99.48,15.08,141.98,41.74V175.83c-110.82,152.79-271.01,252-450.51,261.33V1012.43s100.63,0,100.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.08,275.18c0-15.84-2.14-31.06-6.03-45.33l-44.27-72.51c-19.61-16.91-43.61-26.9-69.54-26.9-22.22,0-43.01,7.33-60.85,20.06v249.34c17.84,12.73,38.63,20.06,60.85,20.06,66.19,0,119.84-64.8,119.84-144.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.61,158.05l43.11,70.62c-8.04-28.61-23.27-53.2-43.11-70.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1768.8 1012.43 1768.8 516.9 2229.14 -237.91 2229.14 686.56 2030.18 1012.43 1768.8 1012.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1323.54,129.01c-197.41-17.21-353.18-215.94-353.18-458.74,0-23.93,1.52-47.43,4.44-70.38h348.74s0,529.12,0,529.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M974.8-400.11c-2.92,22.95-4.44,46.45-4.44,70.38,0,242.8,155.76,441.54,353.18,458.74V437.16c-179.5-9.33-339.69-108.54-450.51-261.33V-400.11s101.77,0,101.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1323.54,437.16V129.01c9.19,.8,18.43,1.35,27.79,1.35,210.4,0,380.96-205.99,380.96-460.09,0-23.93-1.52-47.43-4.44-70.38h40.95s0,649.24,0,649.24c-111.68,117.58-257.69,188.8-417.48,188.8-9.31,0-18.57-.29-27.79-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1768.8,249.13V-400.11s215.47,0,215.47,0c1.75,23.18,2.69,46.65,2.69,70.38,0,230.99-84.49,438.13-218.16,578.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2349.36,275.18c0,57.67,12.28,111.87,33.84,159.02l-154.07,252.36V-237.91s98.92-162.2,98.92-162.2h354.96s0,343.24,0,343.24l-5.7,9.33c-17.81-4.42-36.26-6.74-55.16-6.74-150.66,0-272.8,147.51-272.8,329.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2551.8,158.05l125.52-205.6c.11,.03,.22,.06,.34,.09l-125.04,204.8c-.27,.24-.55,.47-.82,.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2622.16,130.45c-25.94,0-49.93,9.99-69.54,26.9l125.04-204.8c1.79,.45,3.58,.92,5.36,1.41V150.51c-17.84-12.73-38.63-20.06-60.85-20.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2508.68,228.67l-125.48,205.53c-21.56-47.15-33.84-101.35-33.84-159.02,0-181.96,122.14-329.46,272.8-329.46,18.9,0,37.34,2.32,55.16,6.74l-125.52,205.6c-19.84,17.42-35.08,42-43.11,70.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2508.68,228.67l43.11-70.62c.27-.24,.55-.47,.82-.71l-44.27,72.51c.11-.4,.22-.79,.33-1.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1768.8,516.9V249.13c133.67-140.73,218.16-347.87,218.16-578.86,0-23.73-.94-47.2-2.69-70.38h244.86s0,162.2,0,162.2l-460.33,754.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1351.33,130.36c-9.36,0-18.6-.55-27.79-1.35V-400.11s404.32,0,404.32,0c2.92,22.95,4.44,46.45,4.44,70.38,0,254.1-170.56,460.09-380.96,460.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1222.91,1012.43c61.8-68.13,100.58-166.21,100.58-275.23,0-205.76-138.11-372.56-308.49-372.56-51.2,0-99.48,15.08-141.98,41.74V175.83c110.82,152.79,271.01,252,450.51,261.33V1012.43s-100.63,0-100.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2502.33,275.18c0-15.84,2.14-31.06,6.03-45.33l44.27-72.51c19.61-16.91,43.61-26.9,69.54-26.9,22.22,0,43.01,7.33,60.85,20.06v249.34c-17.84,12.73-38.63,20.06-60.85,20.06-66.19,0-119.84-64.8-119.84-144.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2551.8,158.05l-43.11,70.62c8.04-28.61,23.27-53.2,43.11-70.62Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco);
export default __webpack_public_path__ + "static/media/deco.96d9f4aeeabbe85ae52d5a343f7c4b42.svg";
export { ForwardRef as ReactComponent };